import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import HoverIcon from "../hoverIcon/HoverIcon";

import ratesAnimation from "../../images/animated/rates.json";
import supportAnimation from "../../images/animated/support.json";
import shipAnimation from "../../images/animated/ship.json";
import itineraryImage from "../../images/itinerary-image.png";

const Features = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true for mobile

  return (
    <Box
      sx={{ textAlign: "center", px: { xs: 2, md: 0 }, py: { xs: 4, md: 8 } }}
    >
      {/* Top Image */}
      <Box
        sx={{
          mb: { xs: "1.5rem", md: "3rem" },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={itineraryImage}
          alt="Itinerary"
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>

      {/* Headings */}
      <Typography
        variant="h3"
        sx={{
          fontWeight: 800,
          fontSize: { xs: "1.8rem", md: "2.8rem" },
          mb: 1,
          color: "var(--secondary-blue)",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        Why Ship With Us
      </Typography>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1rem", md: "1.5rem" },
          mb: { xs: "1.5rem", md: "2rem" },
          color: "text.primary",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        Discover How We Simplify Shipping for Your Business
      </Typography>

      {/* Feature Icons */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(3, 1fr)",
          },
          gap: { xs: "1.5rem", md: "2.5rem" },
          px: { xs: 0, md: "3rem" },
        }}
      >
        <HoverIcon
          animationData={ratesAnimation}
          title="Enterprise Rates Made Easy"
          description={
            isMobile
              ? "Get instant quotes from top carriers. Enter shipment details and choose the best option."
              : "Get instant real-time quotes from top Canadian carriers with our exclusive pre-negotiated rates. Simply enter your shipment details and choose what fits your needs."
          }
          size={isMobile ? 60 : 80}
          loop={isMobile} // <-- loop if on mobile
          hover={!isMobile} // <-- enable hover only if not mobile
        />

        <HoverIcon
          animationData={shipAnimation}
          title="Quote, Book & Ship Seamlessly"
          description={
            isMobile
              ? "Compare prices, book shipments, and track all steps in one place."
              : "Easily compare prices and delivery speeds, book shipments, and track every step — all from one platform with full visibility."
          }
          size={isMobile ? 60 : 80}
          loop={isMobile}
          hover={!isMobile}
        />

        <HoverIcon
          animationData={supportAnimation}
          title="Dedicated Shipping Support"
          description={
            isMobile
              ? "Access expert advisors and responsive customer service when you need it."
              : "Access expert advisors, responsive customer service, and streamlined billing support when you need it most."
          }
          size={isMobile ? 60 : 80}
          loop={isMobile}
          hover={!isMobile}
        />
      </Box>
    </Box>
  );
};

export default Features;
